<template>
  <div>
    <div
      klickbox-edit-item="general"
      :klickbox-edit-label="$t('edit.canvas.general_styles')"
      class="kbx-welcome">
      <div class="kbx-content">
        <description></description>
        <title-preview></title-preview>
        <buttons></buttons>
      </div>
    </div>
  </div>
</template>

<script>
import TitlePreview from './Title';
import Description from './Description';
import Buttons from './Buttons';

export default {
  components: {
    TitlePreview,
    Description,
    Buttons,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?7090a3ab
 **/